import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteOrcamentoCotacao(id: string) {
  return useMutation(
    "/v1/orcamento",
    async (cotacaoId: string) => {
      const { data } = await http.delete(
        `/v1/orcamento/${id}/cotacao/${cotacaoId}`
      );
      return data as { id: string };
    },
    { retry: false }
  );
}

export default useDeleteOrcamentoCotacao;
